import { ASSETS } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";

export function PageHeader({ eyebrow, title, highlight, subtitle, image, children }) {
  return (
    <section className="relative pt-32 pb-16 sm:pt-40 sm:pb-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={image || ASSETS.clinicHuddle} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 page-vignette" />
        <div className="absolute inset-0 court-glow" />
      </div>
      <div className="container-x relative">
        <Reveal>
          {eyebrow && (
            <span className="inline-block mb-4 text-xs font-bold uppercase tracking-[0.3em] text-blaze-orange">
              {eyebrow}
            </span>
          )}
          <h1 className="font-display font-black uppercase leading-[0.95] tracking-tight text-4xl sm:text-6xl lg:text-7xl text-white">
            {title} {highlight && <span className="text-gradient-blaze">{highlight}</span>}
          </h1>
          {subtitle && <p className="mt-5 max-w-2xl text-base sm:text-lg text-white/70 leading-relaxed">{subtitle}</p>}
          {children && <div className="mt-8 flex flex-wrap gap-4">{children}</div>}
        </Reveal>
      </div>
    </section>
  );
}
